// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__F4HRP","list":"PatternAutocomplete_list__2Zz27"};